<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="计划名称" prop="campaignName">
        <el-input v-model="form.campaignName" size="medium" placeholder="请输入计划名称"/>
      </el-form-item>
      <el-form-item label="广告主" prop="advertiserId">
        <el-select v-model="form.advertiserId" placeholder="请选择广告主" size="medium" filterable style="width: 100%;">
          <el-option
            v-for="item in advertiserList"
            :key="item.id"
            :label="item.advertiserName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="点击追踪 URL" prop="clickTrackUrl">
        <el-input v-model="form.clickTrackUrl" size="medium" placeholder="请输入点击追踪 URL"/>
      </el-form-item>
      <el-form-item label="出价" prop="bidPrice">
        <el-input-number v-model="form.bidPrice" :min="0" :precision="2" size="medium" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="预算" prop="budget">
        <el-input-number v-model="form.budget" :min="0" size="medium" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="转化类型" prop="conversionType">
        <el-select v-model="form.conversionType" placeholder="请选择转化类型" size="medium" style="width: 100%;">
          <el-option
            v-for="item in conversionTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">草稿</el-radio>
          <el-radio :label="1">投放中</el-radio>
          <el-radio :label="2">暂停</el-radio>
          <el-radio :label="3">已结束</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addCampaign, updateCampaign } from '@/api/ocpx/campaign'
import { getEnabledAdvertiserList } from '@/api/ocpx/advertiser'
import { CONVERSION_TYPE_LIST } from '@/const/ocpx-conversion-type'

const defaultForm = {
  campaignName: undefined,
  advertiserId: undefined,
  url: undefined,
  clickTrackUrl: undefined,
  bidPrice: undefined,
  budget: undefined,
  conversionType: 1,
  status: 0
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        campaignName: [{ required: true, message: '请输入计划名称', trigger: 'blur' }],
        advertiserId: [{ required: true, message: '请选择广告主', trigger: 'change' }],
        url: [{ required: false, message: '请输入投放 URL', trigger: 'blur' }],
        clickTrackUrl: [{ required: false, message: '请输入点击追踪 URL', trigger: 'blur' }],
        bidPrice: [{ required: false, message: '请输入出价', trigger: 'blur' }],
        budget: [{ required: false, message: '请输入预算', trigger: 'blur' }],
        conversionType: [{ required: false, message: '请选择转化类型', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      advertiserList: [],
      conversionTypeList: CONVERSION_TYPE_LIST
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  created () {
    this.getAdvertiserList()
  },
  methods: {
    getAdvertiserList () {
      getEnabledAdvertiserList().then(res => {
        if (res.code === 200) {
          this.advertiserList = res.data || []
        }
      })
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addCampaign(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateCampaign(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
